<template>
  <div id="resultList" class="resultList">
    <div class="list-table">
      <div v-for="(item, index) in data " :key="index" class="list-table-item">
        <div class="list-table-item__left">
          <div class="margin-top__16 margin-left__16 flex flex-row-start">
            <div :class="{ 'filter-button1': true, 'filter-button-show': item.isRecommend }">最超值</div>
            <div :class="{ 'filter-button1 margin-left_8': true, 'filter-button-show': item.isQuickest }">
              时效最快</div>
            <div :class="{ 'filter-button1 margin-left_8': true, 'filter-button-show': item.isCheapest }">
              价格最低</div>
          </div>
          <div class="flex flex-column-center padding-top_7 padding-bottom_7">
            <img
              v-if="item.businessType==1"
              src="@/assets/img/client/check/Express.png"
              width="16"
              height="16"
            >
            <img
              v-else-if="item.businessType==2"
              src="@/assets/img/client/check/Air.png"
              width="16"
              height="16"
            >
            <img
              v-else-if="item.businessType==3"
              src="@/assets/img/client/check/Ocean.png"
              width="16"
              height="16"
            >
            <img
              v-else-if="item.businessType==4"
              src="@/assets/img/client/check/Ocean.png"
              width="16"
              height="16"
            >
            <div class="margin-left_8">
              <span class="text1">{{ item.channelName }} </span> |
              <span>
                <span class="text2">预计</span>
                <span class="text1">{{ item.workDays }} </span>
                <span class="text2">天</span>
              </span>
            </div>
          </div>
          <div class="flex flex-column-center">
            <div
              v-if="item.businessType == 1"
              class="flex flex-1 flex-column-center padding-top_6 padding-bottom_6"
            >
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/address-icon.png" alt="air" width="16" height="16">
                <span class="text1 margin-left_8">{{ item.originZipcode }},
                  {{ item.originNameCn }}</span>
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/air-icon.png" alt="air" width="16" height="16">
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/address-icon.png" alt="air" width="16" height="16">
                <span class="text1 margin-left_8">{{ item.destinationZipcode }},
                  {{ item.destinationName }}</span>
              </div>
            </div>
            <div
              v-if="item.businessType == 2"
              class="flex flex-1 flex-column-center padding-top_6 padding-bottom_6"
            >
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/address-icon.png" alt="air" width="16" height="16">
                <span class="text1 margin-left_8">{{ item.originZipcode }},
                  {{ item.originNameCn }}</span>
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/exp-icon.png" alt="air" width="16" height="16">
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <span class="text1 margin-left_8">{{ item.startPortCode }}</span>
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/air-icon.png" alt="air" width="16" height="16">
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <span class="text1 margin-left_8">{{ item.destPortCode }}</span>
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/exp-icon.png" alt="air" width="16" height="16">
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/address-icon.png" alt="air" width="16" height="16">
                <span class="text1 margin-left_8">{{ item.destinationZipcode }},
                  {{ item.destinationName }}</span>
              </div>
            </div>
            <div
              v-if="item.businessType == 3"
              class="flex flex-1 flex-column-center padding-top_6 padding-bottom_6"
            >
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/address-icon.png" alt="air" width="16" height="16">
                <span class="text1 margin-left_8">{{ item.originZipcode?item.originZipcode+',':'' }}
                  {{ item.originNameCn }}</span>
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/Ocean.png" alt="Ocean" width="16" height="16">
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/exp-icon.png" alt="air" width="16" height="16">
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/address-icon.png" alt="air" width="16" height="16">
                <span class="text1 margin-left_8">#{{ item.fbaStoreCode }} -
                  {{ item.destinationZipcode }} ,
                  {{ item.destinationCountryNameCn }}</span>
              </div>
            </div>
            <div
              v-if="item.businessType == 4"
              class="flex flex-1 flex-column-center padding-top_6 padding-bottom_6"
            >
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/address-icon.png" alt="air" width="16" height="16">
                <span class="text1 margin-left_8">{{ item.originZipcode }},
                  {{ item.originNameCn }}</span>
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/exp-icon.png" alt="air" width="16" height="16">
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <span class="text1 margin-left_8">{{ item.startPortCode }}</span>
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/Ocean.png" alt="air" width="16" height="16">
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <span class="text1 margin-left_8">{{ item.destPortCode }}</span>
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/exp-icon.png" alt="air" width="16" height="16">
              </div>
              <div class="line margin-left_8 margin-right_8" />
              <div class="flex flex-column-center">
                <img src="@/assets/img/client/check/address-icon.png" alt="air" width="16" height="16">
                <span class="text1 margin-left_8">{{ item.destinationZipcode }},
                  {{ item.destinationName }}</span>
              </div>
            </div>
            <div
              class="margin-left_16 inline-ask-btn flex flex-column-center flex-row-center"
              @click.stop.prevent="clickChat(item)"
            >
              <img src="@/assets/img/client/check/ask.png" alt="air" width="16" height="16">
              <span class="margin-left_4">立即咨询</span>
            </div>
          </div>
        </div>
        <div class="list-table-item__center">
          <div v-if="item.totalAmount>0" class="padding-top_5 padding-bottom_5 text1">CNY ￥{{ item.totalAmount.toFixed(2) }}</div>
          <div v-else class="padding-top_5 padding-bottom_5 text1">单询</div>
          <div class="flex flex-row-center padding-top_7 padding-bottom_7">
            <div class="text2">价格有效期：</div>
            <div class="text3">{{ item.expirationTimeCn }}</div>
          </div>
        </div>
        <div class="list-table-item__right flex flex-column flex-row-between flex-column-center">
          <button class="choose-btn" @click="toOrder(item)"><span>选择</span></button>
          <button class="detail-btn" @click="toDetail(item)"><span>明细</span></button>
        </div>
      </div>
    </div>
    <ChatDialog v-if="chatVisible" ref="ChatDialog" @close="closeChat" />
    <DetailDialog :is-show="detailDialogShow" :detail="detailInfo" @close="(val) => { detailDialogShow = val}" />
    <ConfirmOrder v-show="confirmOrderVisible" ref="ConfirmOrder" @close="closeConfirm" />
  </div>
</template>

<script>
import {
  CreateFBAOrder,
  CreateAirOrder,
  CreateExpOrder,
  CreateSeaOrder
} from '@/api/order.js'
import {
  GetChatUserId
} from '@/api/user.js'
import ChatDialog from '@/client/home/chatBox/index.vue'
import DetailDialog from './DetailDialog.vue'
import ConfirmOrder from '@/client/home/placeAnOrder/index.vue'
export default {
  name: 'ResultList',
  components: {
    // 组件的引用
    ChatDialog,
    DetailDialog,
    ConfirmOrder
  },
  props: {
    // 父辈向子辈传参
    sortTitle: ''
  },
  data() {
    return {
      data: undefined,
      inputData: undefined,
      chatVisible: false,
      detailDialogShow: false,
      detailInfo: {},
      confirmOrderVisible: false
    }
  },
  computed: {},
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    // this.openConfirm('FBA2407110005', 3)
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    closeConfirm() {
      this.confirmOrderVisible = false
    },
    // 查看渠道详情
    toDetail(item) {
      this.detailInfo = {
        ...item,
        ...this.inputData
      }
      this.detailDialogShow = true
    },
    closeChat() {
      this.chatVisible = false
    },
    clickChat(item) {
      GetChatUserId().then(res => {
        if (res.code === 200) {
          this.chatVisible = true
          this.$nextTick(() => {
            this.$refs.ChatDialog.init(this.inputData, item, res.data)
          })
        }
      })
    },
    init(data, inputData) {
      console.log(JSON.stringify(inputData))
      this.data = data
      this.inputData = inputData
    },
    getSubTotal(item) {
      var total = 0
      if (item.feeList) {
        item.feeList.forEach((item) => {
          total += item.amount
        })
      }
      if (
        item.startLiftgateAmount > 0 &&
					item.businessType != 2 &&
					item.businessType != 4
      ) {
        total += item.startLiftgateAmount
      }
      if (
        item.pickupAmount > 0 &&
					item.businessType != 2 &&
					item.businessType != 4
      ) {
        total += item.pickupAmount
      }
      return total.toFixed(2)
    },
    getBusinessType(item) {
      switch (item.businessType) {
        case 1:
          return `Express`
        case 2:
          return `Air`
        case 3:
          return `Ocean`
        case 4:
          return `Ocean`
      }
    },
    getMode(item) {
      switch (item.businessType) {
        case 1:
          return `国际快递 | 预计${item.workDays} 天 `
        case 2:
          return `空运 | 预计${item.workDays} 天 | (${this.GetType(item)})`
        case 3:
          return `海运 | 预计${item.workDays} 天`
        case 4:
          return `海运 | 预计${item.workDays} 天 | (${this.GetType(item)})`
      }
    },
    GetType(item) {
      switch (item.businessType) {
        case 2:
          switch (item.calculationType) {
            case 1:
              return `门到门`
            case 2:
              return `门到机场`
            case 3:
              return `机场到机场`
            case 4:
              return `机场到门`
          }
          break
        case 4:
          switch (item.calculationType) {
            case 1:
              return `门到门`
            case 2:
              return `门到港口`
            case 3:
              return `港口到港口`
            case 4:
              return `港口到门`
          }
          break
      }
      return ''
    },
    getAddress(item) {
      switch (item.businessType) {
        case 1:
          return `${item.originZipcode},${item.originName} - ${this.inputData.DestinationZipCode},${this.inputData.DestinationAddressCode}`
        case 2:
          return `${this.inputData.OriginZipCode},${this.inputData.OriginAddressCode} - ${item.startPortCode} - ${item.destPortCode} - ${this.inputData.DestinationZipCode},${this.inputData.DestinationAddressCode}`
        case 3:
          return `${this.inputData.OriginZipCode},${this.inputData.OriginAddressCode} —— #${this.inputData.FbaWarehouseCode} - ${item.destinationZipcode},${item.destinationName}`
      }
    },
    changeType(item) {
      switch (item.businessType) {
        case 1:
          return `Express`
        case 2:
          return `Air`
        case 3:
          return `Ocean`
        case 4:
          return `Ocean`
      }
    },
    // 方法
    // 点击标题展开内容
    clkxShow(item, index) {
      this.data.forEach((res, i) => {
        if (index === i) {
          this.$set(res, 'isTrue', !item.isTrue)
        }
      })
    },
    openConfirm(orderNo, businessType) {
      this.confirmOrderVisible = true
      this.$nextTick(() => {
        this.$refs.ConfirmOrder.init(orderNo, businessType)
      })
    },
    toOrder(item) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
        customClass: 'is-loading-style'
      })
      switch (item.businessType) {
        case 1: // 快递
          this.createExpOrder(item, loading)
          break
        case 2: // 空运
          this.createAirOrder(item, loading)
          break
        case 3: // fab
          this.createFbaOrder(item, loading)
          break
        case 4: // 海运
          this.createSeaOrder(item, loading)
          break
      }
    },
    createFbaOrder(item, loading) {
      var param = {
        isDraft: true,
        startCityId: this.inputData.OriginCityId,
        destCountryId: this.inputData.DestinationCountryId,
        storeCode: this.inputData.FbaWarehouseCode,
        quantity: this.inputData.TotalQuantity,
        weight: this.inputData.TotalWeight,
        volume: this.inputData.TotalVolume,
        channelId: item.channelId,
        totalValue: this.inputData.GoodsValue,
        buyInsurance: this.inputData.IsInsurance ? 1 : 0,
        productName: this.inputData.GoodsName,
        goodsReadyType: this.inputData.GoodsReadyType,
        goodsReadyTime: this.inputData.GoodsReadyTime,
        isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
        isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
        isBond: this.inputData.IsBond ? 1 : 0,
        bondType: this.inputData.BondType,
        isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
        isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
        cargoTypeIds: this.inputData.GoodsType
      }
	  if (!this.inputData.FbaWarehouseCode) {
		  param.addressType = 100
		  param.consignee = {
			  zipCode: this.inputData.DestinationZipCode,
			  countryId: this.inputData.DestinationCountryId,
			  cityName: this.inputData.DestinationAddressCode
		  }
	  }
      CreateFBAOrder(param).then(res => {
        loading.close()
        if (res.code === 200) {
          var orderNo = res.data
          this.openConfirm(orderNo, 3)
        }
      }).finally(() => {
        loading.close()
      })
    },
    createExpOrder(item, loading) {
      var param = {
        isDraft: true,
        startCityId: this.inputData.OriginCityId,
        destCityId: this.inputData.DestinationCityId,
        destCountryId: this.inputData.DestinationCountryId,
        quantity: this.inputData.TotalQuantity,
        weight: this.inputData.TotalWeight,
        volume: this.inputData.TotalVolume,
        channelId: item.channelId,
        cargoValue: this.inputData.GoodsValue,
        feeList: item.feeList,
        orderAmount: item.totalAmount,
        buyInsurance: this.inputData.IsInsurance ? 1 : 0,
        productName: this.inputData.GoodsName,
        goodsReadyType: this.inputData.GoodsReadyType,
        goodsReadyTime: this.inputData.GoodsReadyTime,
        isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
        isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
        totalValue: this.inputData.GoodsValue,
        destZipCode: this.inputData.DestinationZipCode,
        cargoTypeIds: this.inputData.GoodsType
      }
      CreateExpOrder(param).then((res) => {
        loading.close()
        if (res.code === 200) {
          var orderNo = res.data
          this.openConfirm(orderNo, 1)
        }
      }).finally(() => {
        loading.close()
      })
    },
    createAirOrder(item, loading) {
      var priceInfo = item.feeList.find((item) => item.name === 'AIR FREIGHT')
      var param = {
        airChannelId: item.channelId,
        airCompanyCode3: item.airCompanyCode3,
        destAirPortCode3: item.destPortCode,
        startAirPortCode3: item.startPortCode,
        weight: item.totalWeight,
        volume: item.totalVolume,
        quantity: item.totalQuantity,
        validTerm: item.workDays,
        airCompanyId: item.airCompanyId,
        airArrivalType: item.airArrivalType,
        orderServiceType: item.calculationType,
        planDeliveryTime: item.goodsReadTime,
        queryValidTime: item.expirationTime,
        orderTrafficAmount: priceInfo.amount,
        orderAmount: item.totalAmount,
        chargeWeight: priceInfo.units,
        costUnitPrice: priceInfo.unitPrice,
        goodsReadyType: this.inputData.GoodsReadyType,
        isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
        buyInsurance: this.inputData.IsInsurance ? 1 : 0,
        goodsValue: this.inputData.GoodsValue,
        isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
        isBond: this.inputData.IsBond ? 1 : 0,
        bondType: this.inputData.BondType,
        isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
        isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
        bondAmount: item.bondAmount,
        destLiftgateAmount: item.destLiftgateAmount,
        startLiftgateAmount: item.startLiftgateAmount,
        feeList: [
          ...item.feeList.filter((item) => item.name !== 'AIR FREIGHT'),
          ...item.destFeeList,
          ...item.customsFeeList,
          ...item.originFeeList
        ],
        startCityId: item.originCityId,
        destCityId: item.destCityId,
        destCountryId: item.destinationCountryId,
        destSvcId: item.destSvcId,
        pickupAmount: item.pickupAmount,
        cargoIDs: this.inputData.GoodsType.join(',')
      }
      var deliveryInfo = item.destFeeList.find(
        (x) => x.name == 'AIR DELIVERY FREIGHT'
      )
      if (deliveryInfo != undefined) {
        param.deliveryAmount = deliveryInfo.amount
      }
      CreateAirOrder(param).then((res) => {
        loading.close()
        if (res.code === 200) {
          var orderNo = res.data
          this.openConfirm(orderNo, 2)
        }
      }).finally(() => {
        loading.close()
      })
    },
    createSeaOrder(item, loading) {
      var priceInfo = item.feeList.find((item) => item.name === 'SEA FREIGHT')
      var param = {
        shipPortCode: item.startPortCode,
        destPortCode: item.destPortCode,
        channelId: item.channelId,
        quantity: item.totalQuantity,
        weight: item.totalWeight,
        volume: item.totalVolume,
        orderAmount: item.amount,
        ServiceType: item.calculationType,
        planDeliveryTime: item.goodsReadTime,
        charge: priceInfo.units,
        unitPrice: priceInfo.unitPrice,
        costAmount: priceInfo.amount,
        totalAmount: item.totalAmount,
        workDays: item.workDays,
        goodsReadyType: this.inputData.GoodsReadyType,
        isKnowerShipper: this.inputData.IsKnown ? 1 : 0,
        buyInsurance: this.inputData.IsInsurance ? 1 : 0,
        priceEndDate: item.expirationTime,
        shipCompanyCode: item.modeCodes,
        goodsValue: this.inputData.GoodsValue,
        isCustomsBrokerage: this.inputData.IsCustomsBrokerage ? 1 : 0,
        isBond: this.inputData.IsBond ? 1 : 0,
        bondType: this.inputData.BondType,
        isLiftgatePickup: this.inputData.IsLiftgatePickup ? 1 : 0,
        isLiftgateDelivery: this.inputData.IsLiftgateDelivery ? 1 : 0,
        bondAmount: item.bondAmount,
        destLiftgateAmount: item.destLiftgateAmount,
        startLiftgateAmount: item.startLiftgateAmount,
        startCityId: item.originCityId,
        destCityId: item.destCityId,
        destCountryId: item.destinationCountryId,
        feeList: [
          ...item.feeList.filter((item) => item.name !== 'SEA FREIGHT'),
          ...item.destFeeList,
          ...item.customsFeeList,
          ...item.originFeeList
        ],
        destSvcId: item.destSvcId,
        pickupAmount: item.pickupAmount
      }
      var deliveryInfo = item.destFeeList.find(
        (x) => x.name == 'SEA DELIVERY FREIGHT'
      )
      if (deliveryInfo != undefined) {
        param.deliveryAmount = deliveryInfo.amount
      }
      CreateSeaOrder(param).then((res) => {
        loading.close()
        if (res.code === 200) {
          var orderNo = res.data
          this.openConfirm(orderNo, 4)
        }
      }).finally(() => {
        loading.close()
      })
    },
    filteredDestFeeList(item) {
      return item.destFeeList.filter(
        (fee) => fee.name != 'AIR DELIVERY FREIGHT'
      )
    },
    usedDestFeeList(item) {
      return item.destFeeList.filter(
        (fee) => fee.name == 'AIR DELIVERY FREIGHT'
      )
    },
    destFeeSum(item) {
      var list = this.filteredDestFeeList(item)
      if (list) {
        return list
          .reduce((accumulator, item) => accumulator + item.amount, 0)
          .toFixed(3)
      } else {
        return 0
      }
    },
    destFeeUesdSum(item) {
      var list = this.usedDestFeeList(item)
      if (list) {
        return (
          list.reduce((accumulator, item) => accumulator + item.amount, 0) +
						parseFloat(item.destLiftgateAmount)
        ).toFixed(3)
      } else {
        return 0
      }
    },
    customsFeeSum(item) {
      var customsFee = 0
      if (item.customsFeeList) {
        customsFee = parseFloat(
          item.customsFeeList.reduce(
            (accumulator, customsFee) => accumulator + customsFee.amount,
            0
          )
        )
      }
      return (
        parseFloat(item.ISFBondAmount) +
					parseFloat(item.bondAmount) +
					customsFee
      ).toFixed(3)
    },
    originFeeSum(item) {
      if (item.originFeeList) {
        return item.originFeeList
          .reduce(
            (accumulator, customsFee) => accumulator + customsFee.amount,
            0
          )
          .toFixed(3)
      } else {
        return 0
      }
    },
    pickupFeeSum(item) {
      return (
        parseFloat(item.startLiftgateAmount) + parseFloat(item.pickupAmount)
      ).toFixed(3)
    }
  }
}
</script>
<style scoped lang="scss">
	.resultList {
		margin-top: 16px;

		.list-main {
			padding: 0;

			li {
				width: 1200px;
				//height: 160px;
				background: #ffffff;
				border-radius: 8px;
				border: 1px solid rgba(233, 85, 6, 0);
				margin: 8px 0;
				overflow: hidden;
				cursor: pointer;

				.list-item {
					width: 1200px;
					height: 160px;
					background: #ffffff;
					border-radius: 8px;
					border: 1px solid rgba(233, 85, 6, 0);
					display: flex;

					.list-left {
						width: 70%;
						text-align: left;
						margin: 16px;
						border-right: 1px solid #dddddd;

						.div-tag {
							display: flex;

							.list-tag {
								width: 88px;
								height: 25px;
								background: rgba(2, 127, 252, 0.08);
								border-radius: 13px;
								font-size: 13px;
								font-family: PingFangSC, PingFang SC;
								font-weight: 500;
								color: #027ffc;
								text-align: center;
								line-height: 25px;
								margin-left: 5px;
								display: inline-block;
							}
						}

						div:nth-of-type(2),
						div:nth-of-type(3) {
							height: 32px;
							display: flex;
							align-items: center;
							font-size: 14px;
							font-family: D, D;
							font-weight: normal;
							color: #333333;
						}

						button {
							width: 100px;
							height: 32px;
							background: rgba(233, 85, 6, 0);
							border-radius: 8px;
							border: 1px solid rgba(233, 85, 6, 0.24);
							font-size: 14px;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							color: #e95506;
						}

						.p-line {
							width: 16px;
							height: 1px;
							background: #aaaaaa;
							display: block;
							margin: 0 8px;
						}

						.p-plus {
							color: #aaaaaa;
							display: block;
							margin: 0 8px;
						}
					}

					.list-middle {
						width: 20%;
						margin: 18px 16px;
						text-align: center;

						div:nth-of-type(1) {
							font-size: 18px;
							font-family: D-DINExp, D-DINExp;
							font-weight: bold;
							color: #333333;
							height: 32px;
						}

						button {
							width: 108px;
							height: 32px;
							background: #e95506;
							border-radius: 8px;
							border: 1px solid #e95506;
							font-size: 16px;
							font-family: D-DINExp, D-DINExp;
							font-weight: bold;
							color: #ffffff;
							cursor: pointer;
						}

						div:nth-of-type(2) {
							font-size: 13px;
							font-family: D, D;
							font-weight: normal;
							margin: 10px 0;

							span:nth-of-type(1) {
								color: #aaaaaa;
								margin-right: 8px;
							}

							span:nth-of-type(2) {
								color: #333333;
							}
						}

						div:nth-of-type(3) {
							font-size: 13px;
							font-family: D, D;
							font-weight: normal;
							color: #333333;
						}
					}

					.list-right {
						width: 10%;
						font-size: 12px;
						margin: 16px;
						width: 24px;
						height: 128px;
						background: rgba(233, 85, 6, 0.06);
						border-radius: 4px;
						color: #e95506;
						display: flex;
						align-items: center;
						justify-content: center;
					}
				}

				.list-card {
					.card-title {
						width: 895px;
						height: 40px;
						background: rgba(170, 170, 170, 0.08);
						font-size: 14px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 500;
						color: #333333;
						line-height: 40px;
						text-align: left;
						padding-left: 16px;
					}

					.card-table {
						table {
							width: 895px;
							border-collapse: collapse;
							text-align: left;
							padding: 0 8px;

							tr:nth-of-type(1) {
								td {
									font-size: 13px;
									font-family: PingFangSC, PingFang SC;
									font-weight: 550;
									color: #333333;
								}
							}

							tr {
								height: 40px;

								td {
									border-bottom: 1px solid rgba(170, 170, 170, 0.24);
									font-size: 13px;
									font-family: PingFangSC, PingFang SC;
									font-weight: 400;
									color: #333333;
									padding: 0 16px;
								}

								td:last-child {
									text-align: right;
								}
							}
						}
					}

					.card-subtotal {
						font-size: 14px;
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						color: #333333;
						height: 40px;
						line-height: 40px;
						text-align: right;
						padding-right: 16px;
					}

					.card-total {
						height: 40px;
						line-height: 40px;
						text-align: right;
						background: rgba(2, 127, 252, 0.08);
						font-size: 16px;
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						color: #333333;
						padding-right: 16px;
					}

					.card-remarks {
						width: 863px;
						height: 161px;
						background: rgba(0, 0, 0, 0.02);
						border-radius: 8px;
						margin: 16px;
						text-align: left;
						overflow-y: scroll;

						p {
							padding: 4px 8px;
							margin: 0;
						}

						span {
							padding: 0 8px;
							display: block;
						}
					}
				}
			}
		}

		.list-table {
			width: 1200px;

			.list-table-item {
				margin-top: 16px;
				width: 1200px;
				padding: 16px 0;
				display: flex;
				align-items: stretch;
				background: #ffffff;
				box-shadow: 0px 2px 8px 0px rgba(25, 78, 203, 0.04);
				border-radius: 8px;
				border: 1px solid rgba(233, 85, 6, 0);
				transition: border 0.3s;
				box-sizing: border-box;

				&:hover {
					border: 1px solid #3370ff;
				}

				.list-table-item__left {
					width: 776px;
					padding: 0 16px;
					box-sizing: border-box;

					.filter-button-show {
						visibility: visible;
					}

					.filter-button1 {
						visibility: hidden;
						display: inline-block;
						min-width: 64px;
						min-height: 24px;
						padding: 3px 8px;
						font-family: PingFangSC, PingFang SC;
						font-weight: 600;
						font-size: 12px;
						color: #3370ff;
						line-height: 17px;
						// text-align: center;
						font-style: normal;
						background: rgba(2, 127, 252, 0.08);
						border-radius: 8px 0px 8px 0px;
						box-sizing: border-box;
					}

					.text1 {
						display: inline-block;
						font-family: D, D;
						font-weight: normal;
						font-size: 14px;
						color: #333333;
						line-height: 16px;
						text-align: left;
						font-style: normal;
					}

					.text2 {
						display: inline-block;
						font-family: D, D;
						font-family: PingFangSC, PingFang SC;
						font-size: 14px;
						color: #333333;
						line-height: 16px;
						text-align: left;
						font-style: normal;
					}

					.line {
						width: 16px;
						height: 1px;
						background: #aaaaaa;
					}

					.inline-ask-btn {
						width: 96px;
						height: 32px;
						background: rgba(51, 112, 255, 0.04);
						border-radius: 8px;
						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 13px;
							color: #3370ff;
							line-height: 18px;
							text-align: left;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
						}
					}
				}

				.list-table-item__center {
					width: 272px;
					border-left: 1px solid #dddddd;
					border-right: 1px solid #dddddd;
					box-sizing: border-box;

					.text1 {
						font-family: D-DINExp, D-DINExp;
						font-weight: bold;
						font-size: 20px;
						color: #333333;
						line-height: 22px;
						text-align: center;
						font-style: normal;

						&::after {
							position: relative;
							top: -8px;
							left: 3px;
							display: inline-block;
							font-family: D, D;
							font-weight: normal;
							font-size: 12px;
							color: #333333;
							line-height: 13px;
							text-align: left;
							font-style: normal;
						}
					}

					.text2 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #aaaaaa;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text3 {
						font-family: D, D;
						font-weight: normal;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}

					.text4 {
						font-family: PingFangSC, PingFang SC;
						font-weight: 400;
						font-size: 13px;
						color: #333333;
						line-height: 18px;
						text-align: left;
						font-style: normal;
					}
				}

				.list-table-item__right {
					width: 152px;
					box-sizing: border-box;

					.choose-btn {
						outline: none;
						border: none;
						width: 104px;
						height: 32px;
						background: #3370ff;
						border-radius: 8px;
						box-sizing: border-box;

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 600;
							font-size: 14px;
							color: #ffffff;
							line-height: 20px;
							text-align: center;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
						}
					}

					.detail-btn {
						outline: none;
						border: none;
						width: 104px;
						height: 32px;
						background: rgba(51, 112, 255, 0);
						border-radius: 8px;
						border: 1px solid rgba(51, 112, 255, 0.24);

						span {
							display: inline-block;
							font-family: PingFangSC, PingFang SC;
							font-weight: 500;
							font-size: 13px;
							color: #3370ff;
							line-height: 18px;
							text-align: center;
							font-style: normal;
						}

						&:hover {
							cursor: pointer;
						}
					}
				}
			}
		}
	}
</style>
